import { graphlib, layout } from '@dagrejs/dagre';
import { resolveIcon } from '../icons';
const debug = process.env.REACT_APP_DEBUG && false;
export const getLayoutedElements = (nodes, edges, context) => {
    const { rankDirection, rankSeparation, nodeSeparation } = context;
    const rankdir = rankDirection !== 'C' ? rankDirection : 'LR';
    const graph = new graphlib.Graph({ directed: true, multigraph: true, compound: false }).setDefaultEdgeLabel(() => ({}));
    graph.setGraph({ ranker: 'tight-tree', rankdir, ranksep: rankSeparation, nodesep: nodeSeparation });
    nodes.forEach((node) => {
        const { measured, position } = node;
        debug && console.log('getLayoutedElements', 'node', node.type, { measured, position });
        const { width, height } = resolveIcon(node.type, context);
        graph.setNode(node.id, { ...node, width, height });
    });
    edges.forEach((edge) => {
        debug && console.log('getLayoutedElements', 'edge', edge.type);
        graph.setEdge(edge.source, edge.target, edge.data, edge.data?.edgeTypeId);
    });
    layout(graph, { labelpos: 'c' });
    const { width, height } = graph.graph();
    return {
        nodes: nodes.map((node) => {
            const position = graph.node(node.id);
            let x = position.x;
            let y = position.y;
            /** 0 ~ 1 */
            const widthProportion = position.x / (width ?? 1);
            /** 0 ~ 2π */
            const angle = widthProportion * 2 * Math.PI;
            if (rankDirection === 'C' && width && height) {
                x = Math.sin(angle) * (nodeSeparation * nodeSeparation);
                y = -Math.cos(angle) * (nodeSeparation * nodeSeparation);
                const heightProportion = (position.y + rankSeparation) / height;
                const radius = heightProportion;
                x *= radius;
                y *= radius;
            }
            return { ...node, position: { x, y }, data: { ...node.data, rotation: rankDirection === 'C' ? angle : undefined } };
        }),
        edges,
    };
};
